<template>
    <div class="">
        <div class="row p-1">
            <div class="col-lg-4 d-flex align-items-center">
                <span>{{ note.name }}</span>
            </div>
            <div class="col-lg-8">
                <AsyncSelect
                    placeholder="Select Notes"
                    v-model="remarkList"
                    :api-service="noteNameByType"
                    :additional-query="{ type: 'investigation_remarks' }"
                    :label="'name'"
                    :reduce="item => item.name"
                    :is-new-added="true"
                    @newAdd="handleNewAdded"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import handleHospital from '@/services/modules/hospital';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import { useRoute } from "vue-router";

const { noteNameByType, storeNote } = handleHospital();
const route = useRoute();

const props = defineProps({
  note: {
    type: Object,
    required: true
  },
  index: {
    type: Number,
    required: true
  }
});

const emit = defineEmits(['update:noteRemarks']);

const internalNoteNames = ref(null);

const remarkList = computed({
  get() {
    return internalNoteNames.value;
  },
  set(newVal) {
    internalNoteNames.value = newVal;
  }
});

watch(() => props.note.remarks, (newRemarks) => {
  internalNoteNames.value = newRemarks ? newRemarks : null;
}, { immediate: true });

watch(remarkList, (newVal) => {
  emit("update:noteRemarks", {
    index: props.index,
    remarks: newVal,
  });
});

const handleNewAdded = async (newOption) => {
  const res = await storeNote({
    company_id: route.params.companyId,
    type: 'investigation_remarks',
    name: newOption.name,
    status: 'active',
  });
  if(!res.status) {
    console.log('Something went wrong');
    return;
  }
};
</script>